/* eslint-disable eqeqeq */

import Mask from '__components/Mask';
import { EmTouchableOpacity } from 'emrn-design/EmTouchable';
import { LinearGradient } from 'emrn-design/LinearGradient';
import { Spacer } from 'emrn-design/Spacer';
import { rpx } from 'emrn-design/rpx';
import React, { Component } from 'react';
import { StyleSheet, View, Text, Image, ImageBackground } from 'react-native';

interface Props {
  onPress?: Function;
  onClose?: Function;
}

interface State {
  isShow: boolean;
  money: string;
  rewardIndex: string;
}

export class MonthRewardPop extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShow: false,
      money: '',
      rewardIndex: '',
    };
  }

  show = (money: string, rewardIndex: string) => {
    this.setState({ isShow: true, money, rewardIndex });
  };

  hide = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { onPress, onClose } = this.props;
    const { isShow, money, rewardIndex } = this.state;
    let url =
      money == '500'
        ? require('../../images/invite/jdk5.png')
        : money == '300'
        ? require('../../images/invite/jdk3.png')
        : money == '200'
        ? require('../../images/invite/jdk2.png')
        : money == '100'
        ? require('../../images/invite/jdk1.png')
        : money == '50'
        ? require('../../images/invite/jdk50.png')
        : require('../../images/invite/jdk5.png');
    return (
      <>
        {isShow ? (
          <Mask>
            <View style={styles.content}>
              <ImageBackground source={require('../../images/invite/monthDia.png')} style={styles.main}>
                <Spacer size={rpx(120)} />
                <Image style={styles.jdkImg} source={url} resizeMode={'stretch'} />
                <Text style={styles.text1}>
                  <Text style={{ color: '#FF2233' }}>{`${money}元`}</Text>
                  京东卡
                </Text>
                <Spacer size={rpx(25)} />
                <EmTouchableOpacity
                  style={styles.toWatchImg}
                  activeOpacity={0.9}
                  onPress={() => {
                    onPress && onPress(rewardIndex);
                  }}
                >
                  <Image style={styles.toWatchImg} source={require('../../images/invite/toWatch.png')} />
                </EmTouchableOpacity>
              </ImageBackground>
              <EmTouchableOpacity
                onPress={() => {
                  this.hide();
                }}
              >
                <Image
                  style={styles.closeImg}
                  source={require('../../images/invite/closeBtn.png')}
                  resizeMode={'stretch'}
                />
              </EmTouchableOpacity>
            </View>
          </Mask>
        ) : null}
      </>
    );
  }
}

const styles = StyleSheet.create({
  content: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  main: {
    width: rpx(300),
    height: rpx(394),
    borderRadius: rpx(12),
    alignItems: 'center',
    //justifyContent:'center',
    paddingHorizontal: rpx(25),
  },
  text: {
    fontSize: rpx(24),
    color: '#3A5DD7',
    marginTop: rpx(35),
    marginBottom: rpx(23),
  },
  text1: {
    fontSize: rpx(15),
    color: '#333333',
    marginTop: rpx(3),
    marginBottom: rpx(12),
  },
  jdkImg: {
    width: rpx(190),
    height: rpx(145),
  },
  btnText: {
    fontSize: rpx(16),
    color: '#ffffff',
  },
  toWatchImg: {
    width: rpx(211),
    height: rpx(41),
  },
  taskBtn: {
    width: rpx(250),
    height: rpx(40),
    borderRadius: rpx(20),
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeImg: {
    marginTop: rpx(20),
    width: rpx(56),
    height: rpx(41),
  },
});
